const fetchAs = require("./fetchAs");

module.exports = async function fetchFormsConfigData() {
	const formsConfig = await fetchAs({
		endpoint: "forms_config?_format=json",
	});
	if (formsConfig && !formsConfig.error) {
		return formsConfig;
	} else {
		return [];
	}
};
